<template>
    <div class="card">
        <div class="card-header border-0">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0">Últimos diários</h3>
                </div>
                <div class="col text-right">
                    <router-link ref="link" class="btn btn-sm btn-outline-secondary" :to="{name: 'pesquisa'}">
                        <i class="fas fa-search"></i> Pesquisar
                    </router-link>
                </div>
            </div>
        </div>
        <div v-if="loander">
            <loander-ultimos-diarios></loander-ultimos-diarios>
        </div>

        <div v-if="!loander" class="table-responsive">
            <base-table thead-classes="thead-light" :data="diarios">
                <template slot="columns">
                    <th class="text-center">Edição</th>
                    <th>Data</th>
                    <th class="text-right"></th>
                </template>

                <template slot-scope="{row}">
                    <th class="text-center" scope="row">
                        {{row.dia_numero | padDigits}}
                        <span v-if="row.dia_suplementar"> - Suplemento</span>
                    </th>
                    <td>
                        {{row.dia_data_publicacao | getDayHTML }}
                    </td>
                    <td class="text-right">
                        <router-link v-if="!row.dia_suplementar" ref="link" class="btn btn-sm btn-outline-default"
                                     :to="{name: 'diario', params: { dia_numero: row.dia_numero }}">
                            <i class="far fa-file-alt"></i> Detalhe
                        </router-link>
                        <base-button outline size="sm" icon="fas fa-download" @click="dowload(row)" type="danger">
                            Baixar
                        </base-button>
                    </td>
                </template>

            </base-table>
        </div>

    </div>
</template>
<script>
  import {dowloadDiario} from "@/plugins/webdom";
  import LoanderUltimosDiarios from "./LoanderUltimosDiarios";

  export default {
    name: 'ultimos-diarios',
    components: {
      LoanderUltimosDiarios
    },
    props: {
      loander: {
        type: Boolean,
        default: false
      },
      diarios: {
        type: Array,
      }
    },
    data() {
      return {}
    },
    methods: {
      dowload(diario) {
        dowloadDiario(diario)
      }
    }
  }
</script>
<style>
</style>
